import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import Pagination from "components/ui/pagination/Pagination";

export default function MenuEngineeringDataTable({data}) {
    const { t } = useTranslation();

/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const menuEngineeringData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.reports.reports_tables.product")}</Th>
                    <Th>{t("pages.reports.reports_tables.sales")}</Th>
                    <Th>{t("pages.reports.reports_tables.quantity")}</Th>
                    <Th>{t("pages.reports.reports_tables.total_cost")}</Th>
                    <Th>{t("pages.reports.reports_tables.item_profit")}</Th>
                    <Th>{t("pages.reports.reports_tables.total_profit")}</Th>
                    <Th>{t("pages.reports.reports_tables.profit_percentage")}</Th>
                    <Th>{t("pages.reports.reports_tables.popularity")}</Th>
                    <Th>{t("pages.reports.reports_tables.profit_category")}</Th>
                    <Th>{t("pages.reports.reports_tables.popularity_categoty")}</Th>
                    <Th>{t("pages.reports.reports_tables.class")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            menuEngineeringData?.map((item, index) => (
                <Tr key={index}>  
                    <Td>{item?.ProductName}</Td>
                    <Td>{item?.BranchName}</Td>
                    <Td>{item?.Quantity}</Td>
                    <Td> {item?.TotalCost}  </Td>
                    <Td> {item?.ItemProfit} </Td>
                    <Td> {item?.TotalProfit} </Td>
                    <Td> {item?.ProfitPercentage} </Td>
                    <Td> {item?.Popularity} </Td>
                    <Td> {item?.ProfitCat} </Td>
                    <Td> {item?.PopularityCat} </Td>
                    <Td> {item?.Class} </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};

